import { Button } from "@mui/material";
import { ComponentProps, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { DialogShell } from "./DialogShell";

export const YesNoDialog = ({
  open,
  onYes,
  onNo,
  title,
  description,
  yesColor,
  children,
}: {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
  title: string;
  description: string;
  yesColor?: ComponentProps<typeof Button>["color"];
  // further detail below the description, e.g. what else the action affects
  children?: ReactNode;
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: "dialog.yesNo" });

  return (
    <DialogShell
      open={open}
      onClose={onNo}
      title={title}
      description={description}
      // the question is answered with one of the two buttons
      closeButton={false}
      actions={
        <>
          <Button onClick={onNo} variant="outlined" color="inherit" autoFocus>
            {t("no")}
          </Button>
          <Button onClick={onYes} color={yesColor} variant="contained">
            {t("yes")}
          </Button>
        </>
      }
    >
      {children}
    </DialogShell>
  );
};
